if (!customElements.get('nx-canopy-setup')) {
  class NxCanopySetup extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[data-nx-tab]')];
      this.panels = [...this.querySelectorAll('[data-nx-panel]')];
      this.clickHandler = (event) => {
        const button = event.target.closest('[data-nx-tab], [data-nx-switch]');
        if (button && this.contains(button)) this.selectTab(button.dataset.nxTab || button.dataset.nxSwitch, true);
      };
      this.keyHandler = (event) => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (current + this.tabs.length - 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.selectTab(this.tabs[next].dataset.nxTab, true);
      };
      this.submitHandler = (event) => {
        if (!event.target.matches('[data-nx-accessory-form]')) return;
        event.preventDefault();
        this.addAccessory(event.target);
      };
      this.addEventListener('click', this.clickHandler);
      this.addEventListener('keydown', this.keyHandler);
      this.addEventListener('submit', this.submitHandler);
      this.querySelector('[data-nx-tabs]').hidden = false;
      this.querySelectorAll('[data-nx-switch]').forEach((button) => { button.hidden = false; });
      this.selectTab(this.dataset.initialTab === 'accessories' ? 'accessories' : 'canopy');
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.clickHandler);
      this.removeEventListener('keydown', this.keyHandler);
      this.removeEventListener('submit', this.submitHandler);
      this.ready = false;
    }
    selectTab(name, focus = false) {
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.nxTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.nxPanel !== name; });
    }
    async addAccessory(form) {
      if (this.busy || !form.reportValidity()) return;
      const id = Number(form.querySelector('[name="id"]').value);
      const quantity = Number(form.querySelector('[name="quantity"]').value);
      if (!Number.isInteger(id) || !Number.isInteger(quantity) || quantity < 1) return;
      const button = form.querySelector('[name="add"]');
      if (button.disabled) return;
      const error = form.querySelector('[data-nx-error]');
      const status = form.querySelector('[data-nx-status]');
      error.hidden = true;
      status.hidden = true;
      this.busy = true;
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.classList.add('is-loading');
      const drawer = document.querySelector('cart-drawer');
      const drawerSection = drawer?.closest('.shopify-section')?.id.replace('shopify-section-', '');
      const sections = ['cart-icon-bubble'];
      if (drawerSection) sections.push(drawerSection);
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }], sections, sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections?.['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
        const action = window.theme?.settings?.afterAtc;
        if (action === 'page' || action === 'no-js') {
          window.location.assign(window.Shopify.routes.root + 'cart');
        } else if (drawer && drawerSection && data.sections?.[drawerSection]) {
          try { await drawer.renderContents(data, action === 'drawer'); }
          catch { drawer.refresh(true); }
        } else if (drawer) {
          drawer.refresh(true);
        }
        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: id, quantity } }));
        status.textContent = this.dataset.added;
        status.hidden = false;
      } catch (failure) {
        error.textContent = failure.message || this.dataset.error;
        error.hidden = false;
        if (drawer) drawer.refresh(true);
        this.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: error.textContent } }));
      } finally {
        this.busy = false;
        button.disabled = false;
        button.classList.remove('is-loading');
        form.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('nx-canopy-setup', NxCanopySetup);
}
